// import { useContext } from 'react'
import { Context, State } from 'types'
import { createContext, useContext } from 'use-context-selector'

export const initialUser = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  isAdmin: '',
  isManager: '',
  isCompanyManager: '',
  isProjectManager: '',
  isProjectCoordinator: ''
}

export const initialState: State = {
  companies: [],
  documents: [],
  errors: [],
  notices: [],
  projects: [],
  stripeProducts: [],
  templateDocuments: [],
  user: initialUser,
  permissionsList: [],
  project_managers: [],
  project_coordinators: [],
  signatories: [],
  folder_access: [],
  sub_contractors: [],
  super_foremans: [],
  directories:[]
}

export const initialContext: Context = [initialState, () => null]
export const AppContext = createContext(initialContext)
export const useAppContext = () => useContext(AppContext)
